<template>
  <section class="sec_glocalizing_our_practices">
    <div class="big_container">
      <div class="main_contenet">
        <h2 class="sec_heading" v-html="sanitizeHtml(shopifyData.secHeading)" />
        <h4 class="card_heading_b" v-html="sanitizeHtml(shopifyData.subHeading)" />
        <p
          v-for="(value, key) in shopifyData.paragraphData"
          :key="key"
          class="body_text"
          v-html="sanitizeHtml(value.para)"
        />
      </div>
      <div class="sec_content">
        <div class="sec_img">
          <div class="sec_img_inner">
            <div class="images_row">
              <div v-if="shopifyData.collageData[0]" class="figCaption1">
                <img
                  v-lazy="shopifyData.collageData[0].imgUrl.src"
                  :src-placeholder="shopifyData.collageData[0].imgUrl.placeholder"
                  :alt="shopifyData.collageData[0].imgUrl.alt || 'Glocalizing Our Practices Image'"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Glocalizing Our Practices Image"
                  width=""
                  height=""
                />
                <p
                  class="fig_caption"
                  v-html="sanitizeHtml(shopifyData.collageData[0].imageInfo)"
                />
              </div>
              <div v-if="shopifyData.collageData[1]" class="figCaption2">
                <img
                  v-lazy="shopifyData.collageData[1].imgUrl.src"
                  :src-placeholder="shopifyData.collageData[1].imgUrl.placeholder"
                  :alt="shopifyData.collageData[1].imgUrl.alt || 'Glocalizing Our Practices Image'"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Glocalizing Our Practices Image"
                  width=""
                  height=""
                />
                <p
                  class="fig_caption"
                  v-html="sanitizeHtml(shopifyData.collageData[1].imageInfo)"
                />
              </div>
              <div v-if="shopifyData.collageData[2]" class="figCaption3">
                <img
                  v-lazy="shopifyData.collageData[2].imgUrl.src"
                  :src-placeholder="shopifyData.collageData[2].imgUrl.placeholder"
                  :alt="shopifyData.collageData[2].imgUrl.alt || 'Glocalizing Our Practices Image'"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Glocalizing Our Practices Image"
                  width=""
                  height=""
                />
              </div>
            </div>
            <div class="images_row last">
              <div v-if="shopifyData.collageData[3]" class="figCaption4">
                <img
                  v-lazy="shopifyData.collageData[3].imgUrl.src"
                  :src-placeholder="shopifyData.collageData[3].imgUrl.placeholder"
                  :alt="shopifyData.collageData[3].imgUrl.alt || 'Glocalizing Our Practices Image'"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Glocalizing Our Practices Image"
                  width=""
                  height=""
                />
                <p
                  class="fig_caption"
                  v-html="sanitizeHtml(shopifyData.collageData[3].imageInfo)"
                />
              </div>
              <div v-if="shopifyData.collageData[4]" class="figCaption5">
                <img
                  v-lazy="shopifyData.collageData[4].imgUrl.src"
                  :src-placeholder="shopifyData.collageData[4].imgUrl.placeholder"
                  :alt="shopifyData.collageData[4].imgUrl.alt || 'Glocalizing Our Practices Image'"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Glocalizing Our Practices Image"
                  width=""
                  height=""
                />
                <p
                  class="fig_caption"
                  v-html="sanitizeHtml(shopifyData.collageData[4].imageInfo)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sanitizeHtml,
  },
};
</script>

<style scoped>
.sec_glocalizing_our_practices {
  padding: 87px 0 0px;
}

.sec_heading {
  line-height: 44px;
}

.main_contenet {
  max-width: 494px;
  margin: 0 auto;
  width: 100%;
}

.card_heading_b {
  margin: 14px 0;
  text-transform: initial;
}

.body_text {
  line-height: 19px;
  margin-bottom: 20px;
}

.body_text:last-child {
  margin-bottom: 0px;
}

.sec_img {
  margin: 25px auto;
  max-width: 1920px;
}

.images_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.figCaption1 {
  max-width: 345px;
  width: 100%;
}

.figCaption2 {
  max-width: 484px;
  width: 100%;
}

.figCaption3 {
  max-width: 295px;
  width: 100%;
  align-self: flex-start;
}

.figCaption4 {
  max-width: 472px;
  width: 100%;
  margin-top: -68px;
}

.figCaption5 {
  max-width: 571px;
  width: 100%;
}

.images_row.last {
  justify-content: space-evenly;
}

/* Responsive Css Code */
@media screen and (max-width: 991px) {
  .sec_glocalizing_our_practices {
    padding: 80px 0 100px;
  }

  .big_container {
    padding: 0 5px;
  }

  .sec_img {
    margin: 35px 0 70px;
  }

  .main_contenet {
    padding: 0 25px;
  }

  .images_row.last {
    margin-top: 20px;
  }
}

@media screen and (max-width: 767px) {
  .sec_glocalizing_our_practices {
    padding: 38px 0 53px;
  }

  .sec_content {
    margin-top: 43px;
  }

  .sec_img {
    margin: 45px 0 0px;
  }

  .images_row {
    justify-content: space-evenly;
    gap: 15px;
  }

  .fig_caption {
    font-size: 8px;
    line-height: 1;
  }

  .figCaption4 {
    margin-top: -23px;
  }
}

@media screen and (max-width: 480px) {
  .figCaption4 {
    max-width: 165px;
  }

  .figCaption1 {
    max-width: 90px;
  }

  .figCaption3 {
    max-width: 95px;
  }
}
</style>
